import { render, staticRenderFns } from "./Multipicklist.vue?vue&type=template&id=8528e27c&scoped=true"
import script from "./Multipicklist.vue?vue&type=script&lang=js"
export * from "./Multipicklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8528e27c",
  null
  
)

export default component.exports